import { useEffect } from "react";
import Header from "../components/header";

export default function Play() {

    const queryParameters = new URLSearchParams(window.location.search);
    const uid = queryParameters.get("uid");
    const mode = queryParameters.get("mode");

    useEffect(() => {
        if (uid && mode) {
            window.location.href = "bondz://play?uid=" + uid + "&mode=" + mode
        }
        document.title = 'Play - BondZ';
    }, []);

    function background() {
        if (mode == "couple") {
            return "bgpi"
        } else if (mode == "siblings") {
            return "bgg"
        } else if (mode == "telepathy") {
            return "bgpu"
        } else if (mode == "whoofyou") {
            return "bgo"
        } else {
            return "bgb"
        }
    }

    return (
        <div className={"fxc aic h100 " + background()}>
            <Header />
            <div className="c legalc fxc aic pd6416 play">
                <div className="play-h">How to Play?</div>
                <div className="play-p">1. Download 'BondZ - Friends Quiz' from the App Store.</div>
                    <a href="https://apps.apple.com/us/app/bondz-friends-quiz/id6745426789">
                        App Store
                    </a>
                <div className="play-p">2. Click the button below to accept your friends invitation ⬇️</div>
                <a href={"bondz://play?uid=" + uid + "&mode=" + mode}>
                    <div className="btn">
                        Play BondZ 🕹️
                    </div>
                </a>
                <div className="play-s">The link to the app might not work if you've opened this web page through an in-app browser (e.g. Snapchat, Instagram). Open your friends link in an external browser (e.g. Safari, Chrome) and try again.</div>
            </div>
        </div>
    )
}